(ns frontend.test.ui.alert-list
  (:require
   [frontend.routing :as routing]
   [re-frame.core :as rf]
   [ui.components.alert-list.view :as alert-list]
   [ui.components.alert-list.sub :as alert-list-sub]
   [ui.components.alert-list.event :as alert-list-event]))

(defn view-default
  []
  [:div 
   {:class "p-5"}
   [:span
   {:class "mb-2 block text-xl"}
    "Default list"]
   [alert-list/view nil]
   [:button
    {:on-click #(rf/dispatch [::alert-list-event/add-alert
                              {:variant         :success
                               :message-content [:ul
                                                 [:li "test msg"]
                                                 [:li "test msg 2"]]}])}
    [:div
    {:class "mt-2"} 
     "Add message"]]])

(defn view-default-2
  []
  (when (seq @(rf/subscribe [::alert-list-sub/alerts nil]))
    [:div "Default list 2"
     [alert-list/view nil]
     [:button
      {:on-click #(rf/dispatch [::alert-list-event/add-alert
                                {:variant         :success
                                 :message-content [:ul
                                                   [:li "test msg"]
                                                   [:li "test msg 2"]]}])}
      "Add message"]]))

(defn view-danger
  []
  [:div "Danger list"
   [alert-list/view :danger-list]
   [:button
    {:on-click #(rf/dispatch [::alert-list-event/add-alert
                              {:variant         :danger
                               :list-id         :danger-list
                               :hide-in-ms      2000
                               :message-content [:ul
                                                 [:li "test msg"]
                                                 [:li "test msg 2"]]}])}
    "Add message"]])

(defmethod routing/render-view :test.ui/alert-list
  [{:keys [route-params]}]
  [:div
   [view-default]
   [view-default-2]
   [view-danger]])
